import { object, string } from "yup";

import { passwordRegex, passwordCriteria } from "./createPasswordSchema";

const SignUpSchema = object({
  email: string().email().required(),
  password: string().required().matches(passwordRegex, passwordCriteria),
  first_name: string().required(),
  last_name: string().required(),
  clinic_name: string().required(),
  phone: string().required(),
});

export default SignUpSchema;
